import {APIClient} from "@crunchyroll/cx-api-client-lite";

const News = new APIClient({
  getStoryBySlug: {
    path: "/stories",
    method: "GET",
  },
  searchStories: {
    path: "/stories/search",
    method: "GET",
  },
  getSearchCategories: {
    path: "/search-categories",
    method: "GET",
  },
  getWidgetByName: {
    path: "/widget/{name}",
    method: "GET",
  },
});

export default News;
